import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IUserActionResult } from '../types/IUserActionResult';

// this removes/deletes site users

export interface IDeleteUsersParams {
  ids: string[];
}

export interface IDeleteUsersResult extends IUserActionResult {
}

export class DeleteUsersRequest extends Request<IDeleteUsersParams, IDeleteUsersResult> {
  constructor(ids: string[]) {
    super('deleteUsers', { ids: ids });
  }
}
